function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'henna': 'rgb(145, 76, 6)','root': 'rgb(97, 77, 65)','ashby-white': 'rgb(255, 255, 255)','charcoal': 'rgb(79, 68, 68)','space': 'rgb(154, 49, 76)','stratus': 'rgb(41, 36, 146)','tidal': 'rgb(24, 200, 211)','heart': 'rgb(129, 59, 59)','tobacco-brown': 'rgb(82, 63, 61)','dark-kona-brown': 'rgb(132, 65, 10)',};

    this.images = {'cotton-candy-sunset': 'url("//www.dianakauffmandesigns.com/cdn/shop/files/cottoncandysunset_120x.png?v=694060186103858253")','ocean-sunset': 'url("//www.dianakauffmandesigns.com/cdn/shop/files/oceansunset_120x.png?v=13156531658297736165")','ocean-sunrise': 'url("//www.dianakauffmandesigns.com/cdn/shop/files/oceansunrise_120x.png?v=6557039543279609414")','surf-and-sand': 'url("//www.dianakauffmandesigns.com/cdn/shop/files/surfandsand_120x.png?v=16076453266430755544")','ore': 'url("//www.dianakauffmandesigns.com/cdn/shop/files/ore_120x.png?v=15466238097466642320")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
